import { createContext, useState, useEffect } from "react";
import axios from "axios";
import { API_BASE } from "../config/api";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchUser = async () => {
    try {
      const res = await axios.get(
        `${API_BASE}/v1/user/session`,
        { withCredentials: true }
      );
      setUser(res.data?.authenticated ? res.data.user : null);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  // Method to refresh user data after successful login/registration
  const refreshUser = async () => {
    setLoading(true);
    await fetchUser();
  };

  useEffect(() => {
    fetchUser();
  }, []);

  const logout = async () => {
    await axios.get(`${API_BASE}/v1/user/logout`, { withCredentials: true });
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, setUser, logout, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
};
